import TeaserWidget from '~/scripts/widgets/TeaserWidget';

import { renderReactComponent } from '~/scripts/utils';

import './index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');
}

renderReactComponent('teaser-widget', TeaserWidget);
